export default "__VITE_ASSET__BJjU9je6__"